import TextField from "@mui/material/TextField";
import styles from "../rtsScanModule/RtsScanModule.styles";
import Button from "@mui/material/Button/Button";
import { useState } from "react";
import { toast } from "react-toastify";

interface ManualEntryComponentProps {
  onClose: any;
  onSubmit: any;
}

const ManualEntryComponent: React.FC<ManualEntryComponentProps> = ({
  onClose,
  onSubmit,
}) => {
  const [textBarcode, setTextBarcode] = useState("");
  return (
    <>
      <TextField
        style={styles.manualEntryTextField}
        variant="outlined"
        placeholder="Enter barcode manually"
        value={textBarcode}
        onChange={(e) => setTextBarcode(e.target.value)}
      />

      <div style={styles.manualEntryModuleButtons}>
        <Button style={styles.buttonItem} variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          style={styles.buttonItem}
          variant="contained"
          onClick={() => {
            if (textBarcode.trim() === "") {
              toast.error("Blank barcode can't be added.");
              return;
            }
            if (
              textBarcode.trim().length < 3 ||
              textBarcode.trim().length > 30
            ) {
              toast.error(
                "Barcode's length can't be less than 3 , and can't be greater than 30. "
              );
              return;
            }
            onSubmit(textBarcode.trim());
            setTextBarcode("");
          }}
        >
          Confirm
        </Button>
      </div>
    </>
  );
};

export default ManualEntryComponent;
